module.exports = __webpack_public_path__ + "media/images/icon_a5-4613dc137318df4e5e9c5c2ff8e34c2e.png";